import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React, { PropsWithChildren, useEffect } from 'react';
import firebase from 'gatsby-plugin-firebase';
import theme from './theme';

export const App = ({ children }: PropsWithChildren<unknown>) => {
  useEffect(() => {
    firebase.analytics();
  }, []);

  return (
    <ThemeProvider theme={theme} defaultMode="system">
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default App;
